<!-- <p>project-interaction-settings-home works!</p> -->
<div class="container-fluid mb-5 padding-0">
  <div class="conversation-container">
    <!-- Tab Navigation based on project-inbox-home -->
    <div class="ltms-tabs lato-bold-dark">
      <div class="ltms-tab" *ngIf="tabVisblity.questions" [ngClass]="{ 'ltms-active-tab': activeTab === 'questions' }"
        (click)="toggleTab('questions')">
        All questions
      </div>
      <!-- <div class="ltms-tab" *ngIf="tabVisblity.new_questions"
        [ngClass]="{ 'ltms-active-tab': activeTab === 'new_questions' }" (click)="toggleTab('new_questions')">
        Create new question
      </div> -->
      <div class="ltms-tab" *ngIf="tabVisblity.pages" [ngClass]="{ 'ltms-active-tab': activeTab === 'pages' }"
        (click)="toggleTab('pages')">
        Pages
      </div>
      <div class="ltms-tab" *ngIf="tabVisblity.languages" [ngClass]="{ 'ltms-active-tab': activeTab === 'languages' }"
        (click)="toggleTab('languages')">
        Languages
      </div>
      <div class="ltms-tab" *ngIf="tabVisblity.groups" [ngClass]="{ 'ltms-active-tab': activeTab === 'groups' }"
        (click)="toggleTab('groups')">
        Group Question
      </div>
      <div class="ltms-tab" *ngIf="tabVisblity.navigation" [ngClass]="{ 'ltms-active-tab': activeTab === 'navigation' }"
        (click)="toggleTab('navigation')">
        Navigation
      </div>
      <div class="ltms-tab" *ngIf="tabVisblity.custom" [ngClass]="{ 'ltms-active-tab': activeTab === 'custom' }"
        (click)="toggleTab('custom')">
        Custom
      </div>
      <div class="ltms-tab" *ngIf="tabVisblity.draft" [ngClass]="{ 'ltms-active-tab': activeTab === 'draft' }"
        (click)="toggleTab('draft')">
        Review and Publish
      </div>
      <!-- <div class="ltms-tab" [ngClass]="{ 'ltms-active-tab': activeTab === 'offers' }" (click)="toggleTab('offers')">
        Offers
      </div>
      <div class="ltms-tab" [ngClass]="{ 'ltms-active-tab': activeTab === 'campaign' }" (click)="toggleTab('campaign')">
        Campaign
      </div> -->
    </div>

    <!-- Action Buttons -->
    <div *ngIf="showTopControl()"
      class="d-flex align-items-center justify-content-end px-3 py-2 action-buttons-container mt-2">
      <button class="btn btn-primary btn-md me-2" (click)="copyToClipboard()">
        <i class="fa fa-copy me-1"></i> {{(isCopied)?'Copied':'Copy'}}
      </button>
      <button class="btn btn-outline-primary btn-md me-2" (click)="showPreviewModal()">
        <i class="fa fa-eye me-1"></i> Preview
      </button>
      <button class="btn btn-outline-primary btn-md me-2" (click)="saveConversation()">
        <i class="fa fa-save me-1"></i> Save
      </button>
      <button class="btn btn-success btn-md" (click)="publishConversation()">
        <i class="fa fa-check-circle me-1"></i> Publish
      </button>
    </div>

    <!-- Tab Content Areas -->
    <div class="tab-content-container mt-3" *ngIf="configurationLoaded">
      <!-- Questions Tab Content -->
      <div *ngIf="activeTab === 'questions' && tabVisblity.questions" class="tab-content-section">
            <app-litmus-intraction-questionnaire (questionModalEvent)="questionModalEvent($event)"
              (updateQuestionnaire)="updateQuestionnaire($event)"></app-litmus-intraction-questionnaire>
      </div>

      <!--Create new question Tab Content -->
      <!-- <div *ngIf="activeTab === 'new_questions' && tabVisblity.new_questions" class="tab-content-section">
        <app-create-new-question [isDynamicPropertiesEnabled]="isDynamicPropertiesEnabled" [brandDetails]="brandDetails"
          [dynamicPropertiesGroups]="dynamicPropertiesGroups"></app-create-new-question>
      </div> -->

      <!-- Pages Tab Content -->
      <div *ngIf="activeTab === 'pages' && tabVisblity.pages" class="tab-content-section">
        <!-- <div class="card custom-rounded">
          <div class="card-body">
            <app-litmus-intraction-pages [pageconfiguration]="configuration"></app-litmus-intraction-pages>
          </div>
        </div> -->
        <app-litmus-intraction-pages [pageconfiguration]="configuration"></app-litmus-intraction-pages>
      </div>

      <!-- Other tab content placeholders -->
      <div *ngIf="activeTab === 'languages' && tabVisblity.languages" class="tab-content-section">
            <app-litmus-intraction-languages></app-litmus-intraction-languages>
      </div>

      <div *ngIf="activeTab === 'groups' && tabVisblity.groups" class="tab-content-section">
            <app-litmus-intraction-groups></app-litmus-intraction-groups>
      </div>


      <div *ngIf="activeTab === 'navigation' && tabVisblity.navigation" class="tab-content-section">
        <!-- <div class="card custom-rounded">
          <div class="card-body">
            <app-litmus-intraction-navigation></app-litmus-intraction-navigation>
          </div>
        </div> -->
        <app-litmus-intraction-navigation></app-litmus-intraction-navigation>
      </div>

      <div *ngIf="activeTab === 'custom' && tabVisblity.custom" class="tab-content-section">
        <div class="card custom-rounded">
          <div class="card-body">
            <app-litmus-intraction-custom></app-litmus-intraction-custom>
          </div>
        </div>
      </div>

      <div *ngIf="activeTab === 'offers' && tabVisblity.offers" class="tab-content-section">
        <div class="card custom-rounded">
          <div class="card-body">
            <app-litmus-intraction-offers></app-litmus-intraction-offers>
          </div>
        </div>
      </div>

      <div *ngIf="activeTab === 'campaign' && tabVisblity.campaign" class="tab-content-section">
        <div class="card custom-rounded">
          <div class="card-body">
            <app-litmus-intraction-campaign></app-litmus-intraction-campaign>
          </div>
        </div>
      </div>

      <div *ngIf="activeTab === 'draft' && tabVisblity.draft" class="tab-content-section">
      
                    
            <app-litmus-intraction-draft></app-litmus-intraction-draft>
        
       
      </div>

    </div>
    <div class="tab-content-container mt-3" *ngIf="!configurationLoaded">
      <app-ltms-loader></app-ltms-loader>
    </div>
  </div>
</div>

<app-litmus-intraction-preview *ngIf="isPreviewModalOpen" [isModalView]="true"
  (close)="onCLosePreviewModal()"></app-litmus-intraction-preview>

<!-- <style>
  /* Tab navigation styles */
  .ltms-tabs {
    display: flex;
    flex-wrap: wrap;
    background-color: white;
    border-radius: 8px;
    padding: 10px 8px 0;
    box-shadow: 0 2px 5px rgba(0,0,0,0.05);
  }
  
  .ltms-tab {
    padding: 10px 16px;
    margin-right: 8px;
    margin-bottom: 10px;
    cursor: pointer;
    white-space: nowrap;
    font-weight: 500;
    border-radius: 4px 4px 0 0;
    border-bottom: 2px solid transparent;
    transition: all 0.2s ease;
  }
  
  .ltms-tab:hover:not(.ltms-active-tab) {
    background-color: #f8f9fa;
    border-bottom: 2px solid #e9ecef;
  }
  
  .ltms-active-tab {
    color: #007bff;
    border-bottom: 2px solid #007bff;
    background-color: rgba(0,123,255,0.05);
  }
  
  /* Content styling */
  .tab-content-section {
    min-height: 400px;
  }
  
  .question-card, .page-card, .language-card {
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    border: 1px solid #eaeaea;
  }
  
  .question-card:hover, .page-card:hover, .language-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 5px 15px rgba(0,0,0,0.08);
  }
  
  .rating-btn {
    width: 36px;
    height: 36px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  /* Common utility classes */
  .padding-0 {
    padding: 0 !important;
  }
  
  .lato-bold-dark {
    font-family: 'Lato', sans-serif;
    color: #343a40;
  }
  
  .action-buttons-container {
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 2px 5px rgba(0,0,0,0.05);
    padding: 10px 16px;
  }
</style> -->